import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable import/order */
import { forwardRef, } from 'react';
import classNames from 'classnames';
import ApplicationLayoutHeader from './ApplicationLayoutHeader';
import ApplicationLayoutSidebar from './ApplicationLayoutSidebar';
import ApplicationLayoutBody from './ApplicationLayoutBody';
import { initDocumentBootstrapping } from '../../utils/init/initDocumentBootstrapping';
import '../../utils/init/initConfig';
// initializes document bootstrapping - keep the import to avoid being tree-shaken
// noinspection JSIgnoredPromiseFromCall
initDocumentBootstrapping();
const ApplicationLayout = forwardRef((props, ref) => {
    const { className, layoutRef, children } = props, remainingProps = __rest(props, ["className", "layoutRef", "children"]);
    const classes = classNames('ApplicationLayout', className);
    return (_jsx("div", Object.assign({}, remainingProps, { ref: ref || layoutRef, className: classes }, { children: children })));
});
ApplicationLayout.Header = ApplicationLayoutHeader;
ApplicationLayout.Sidebar = ApplicationLayoutSidebar;
ApplicationLayout.Body = ApplicationLayoutBody;
export default ApplicationLayout;
